export default __webpack_public_path__ + "5c3821e9a19bfd4e813ec9451b3046e2.png";